import axios from 'axios';

/**
 * Sort an array of manual revision objects by a version-like field.
 * @param {Array} arr - items to sort
 * @param {string} nested - field name holding the version string (default 'version')
 * @param {boolean} reverse - reverse the result order
 */
export const versionSort = (arr, nested = 'version', reverse = false) => {
  let result = arr;
  try {
    result = arr.sort((b, a) => a[nested].localeCompare(b[nested], undefined, { numeric: true }));
    if (reverse) {
      result = result.reverse();
    }
  } catch (error) {
    console.log('ERROR[versionSort]: ', error);
  }
  return result;
};

/**
 * Download a manual document.
 * The eIFU portal is anonymous: no user headers are attached.
 * Attempts a blob download and falls back to opening the direct link.
 * @param {Event} e - click event
 * @param {string} downloadUrl - file URL
 * @param {string} fileName - target file name
 */
export const handleManualDownload = async (e, downloadUrl, fileName) => {
  if (e) e.preventDefault();
  try {
    const response = await axios({
      url: downloadUrl,
      method: 'GET',
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'manual.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('ERROR[handleManualDownload]:', error);
    // Fallback to direct link if blob download fails
    window.open(downloadUrl, '_blank');
  }
};
